import { render, staticRenderFns } from "./EstadisticasEmailsEventos.vue?vue&type=template&id=10393424"
import script from "./EstadisticasEmailsEventos.vue?vue&type=script&lang=js"
export * from "./EstadisticasEmailsEventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports